import OldInspectionDetails from './OldInspectionDetails';

export default OldInspectionDetails;
